import React from "react";
import { StyleSheet, View, ViewProps } from "react-native";
import { useOnClickOutside } from "usehooks-ts";

interface iPopoverContext {
  isOpen: boolean;
  direction: "bottom" | "top";
  toggle: () => void;
  popoverContentRef: React.Ref<View>;
}

type tPdPopover = {
  direction?: "bottom" | "top";
};

const PdPopoverContext = React.createContext<Partial<iPopoverContext>>({ isOpen: false });

export const PdPopover: React.FC<tPdPopover> = ({ direction = "bottom", children }) => {
  const [isOpen, setOpen] = React.useState(false);
  const popoverContentRef = React.useRef<View>(null);

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClickOutside = () => {
    setOpen(false);
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  useOnClickOutside(popoverContentRef, handleClickOutside);

  return (
    <PdPopoverContext.Provider value={{ isOpen, toggle, popoverContentRef, direction }}>
      <View>{children}</View>
    </PdPopoverContext.Provider>
  );
};

export const PdPopoverTrigger: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { toggle } = React.useContext(PdPopoverContext);
  return React.Children.only(React.cloneElement(children, { onPress: toggle }));
};

export const PdPopoverContent: React.FC<ViewProps> = ({ style, ...rest }) => {
  const { isOpen, popoverContentRef, direction } = React.useContext(PdPopoverContext);

  if (!isOpen) {
    return null;
  }

  return (
    <View
      ref={popoverContentRef}
      style={[
        styles.pdPopoverContent,
        direction === "bottom" ? styles.pdPopoverContentBottom : {},
        direction === "top" ? styles.pdPopoverContentTop : {},
        style,
      ]}
      {...rest}
    />
  );
};

const styles = StyleSheet.create({
  pdPopoverContent: {
    position: "absolute",
  },
  pdPopoverContentBottom: {
    top: 35,
  },
  pdPopoverContentTop: {
    bottom: 45,
  },
});
